var map = {
	"./icon_instrument_accordion.svg": 372,
	"./icon_instrument_acoustic_guitar.svg": 373,
	"./icon_instrument_banjo.svg": 374,
	"./icon_instrument_bass_guitar.svg": 375,
	"./icon_instrument_cello.svg": 376,
	"./icon_instrument_clarinet.svg": 377,
	"./icon_instrument_computer.svg": 378,
	"./icon_instrument_default.svg": 379,
	"./icon_instrument_double_bass.svg": 380,
	"./icon_instrument_drums.svg": 381,
	"./icon_instrument_electric_guitar.svg": 382,
	"./icon_instrument_euphonium.svg": 383,
	"./icon_instrument_flute.svg": 384,
	"./icon_instrument_french_horn.svg": 385,
	"./icon_instrument_harmonica.svg": 386,
	"./icon_instrument_keyboard.svg": 387,
	"./icon_instrument_mandolin.svg": 388,
	"./icon_instrument_oboe.svg": 389,
	"./icon_instrument_other.svg": 181,
	"./icon_instrument_piano.svg": 390,
	"./icon_instrument_saxophone.svg": 391,
	"./icon_instrument_trombone.svg": 392,
	"./icon_instrument_trumpet.svg": 393,
	"./icon_instrument_tuba.svg": 394,
	"./icon_instrument_ukelele.svg": 395,
	"./icon_instrument_unknown.svg": 396,
	"./icon_instrument_upright_bass.svg": 397,
	"./icon_instrument_viola.svg": 398,
	"./icon_instrument_violin.svg": 399,
	"./icon_instrument_vocal.svg": 400,
	"./icon_instrument_voice.svg": 401
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 371;